
import { worldCountries } from '@/data/countries/index';
import { worldCities } from '@/data/cities';

// Validate and return only countries with valid data
export const getValidCountries = () => {
  return worldCountries.filter(country => 
    country.slug && 
    country.name && 
    country.slug.length > 0 &&
    country.name.length > 0
  );
};

// Validate and return only cities with valid data
export const getValidCities = () => {
  return worldCities.filter(city => 
    city.slug && 
    city.name && 
    city.country &&
    city.slug.length > 0 &&
    city.name.length > 0 &&
    city.coordinates &&
    typeof city.coordinates.lat === 'number' &&
    typeof city.coordinates.lng === 'number'
  );
};

// Get cities by country for sitemap organization
export const getCitiesByCountry = () => {
  const validCities = getValidCities();
  const citiesByCountry: Record<string, typeof validCities> = {};
  
  validCities.forEach(city => {
    if (!citiesByCountry[city.country]) {
      citiesByCountry[city.country] = [];
    }
    citiesByCountry[city.country].push(city);
  });
  
  return citiesByCountry;
};

// Validate city data integrity
export const validateCityData = (city: any): boolean => {
  return !!(
    city &&
    typeof city === 'object' &&
    city.slug &&
    city.name &&
    city.country &&
    city.coordinates &&
    typeof city.coordinates.lat === 'number' &&
    typeof city.coordinates.lng === 'number' &&
    !isNaN(city.coordinates.lat) &&
    !isNaN(city.coordinates.lng) &&
    city.coordinates.lat >= -90 &&
    city.coordinates.lat <= 90 &&
    city.coordinates.lng >= -180 &&
    city.coordinates.lng <= 180
  );
};
